export const TvmImageSlider = (function () {

    TvmImageSlider.options = TvmImageSlider.options || {
        autoplay: false,
        slidesToShow: 1,
        speed: 320,
        dots: true,
        appendArrows: '.tvm-event__image-slider-inner .slick-list',
    };

    function TvmImageSlider(target) {
        this.sliderContainer = target;
        this.slider = this.sliderContainer.find(".tvm-event__image-slider-inner");
        this.sliderOptions = TvmImageSlider.options;
        this.init();
    }

    TvmImageSlider.prototype.init = function () {

        this.slider.on('init', appendPreviewTumnbs.bind(this));

        function appendPreviewTumnbs() {
            const dots = this.slider[0].querySelectorAll('.slick-dots li');

            if(dots.length > 0) {
                const slides = this.slider[0].querySelectorAll('.slick-slide:not(.slick-cloned)');

                for(let i = 0; i < dots.length; i ++) {
                    const dot = dots[i];
                    const image = slides[i].dataset.thumbnailSrc;

                    const img = document.createElement('img');
                    img.src = image;
                    dot.appendChild(img);
                }
            }
        }

        this.slider.slick(this.sliderOptions);
    };

    return TvmImageSlider;
})();
